import styled from 'styled-components'

export const SearchPageContainer = styled.div`
    display: flex;
    margin-top: 100px;
    flex-direction: column;
    align-items: center;
`
export const ToggleSearchFilter = styled.div`
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
`
export const FilterContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
`